/*
 * @Author: your name
 * @Date: 2021-08-26 17:32:54
 * @LastEditTime: 2021-10-01 13:59:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \aftermarket\src\settings.js
 */
module.exports = {
  title: '仪器设备维修维护管理平台',
  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,
  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
};